export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7778.c4e8a0d9.jpg";